import { useContext } from 'react';
import { ViewportPageIndexContext } from '../ViewportPageIndexContext';

export const useViewportPageIndexContext = () => {
  const context = useContext(ViewportPageIndexContext);
  if (!context) {
    throw new Error('useViewportPageIndexContext must be used within an ViewportPageIndexContext.Provider');
  }
  return context;
};
